import { changePageState } from 'actions/import';
import { NEW_EDIT_ICON } from 'constants/commonIcons';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerDomain, getUserCustomer } from 'selectors/auth';
import { getIntegrationSettings } from 'selectors/integrationSettings';
import { useHistory } from 'utils/urls';
import { useCasesOptions } from './IntegrationSettingsUseCases';

const IntegrationSettingsCard: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const integrationSettings = useSelector(getIntegrationSettings);
  const customer = useSelector(getUserCustomer);

  const customerDomain = useSelector(getCustomerDomain);

  const handleEditIntegrationSettings = (): void => {
    dispatch(changePageState(3));
    history.pushLookup({
      routeName: 'customer-import',
      queryParams: { only_integration_settings: 'true' },
      customerDomain,
    });
  };

  return (
    <div className="w-112 h-80 pt-6 px-6 pb-8 flex flex-col gap-4 text-body bg-white border border-litlingo-gray-2 rounded">
      <div className="flex flex-row justify-between">
        <span className="text-heading-2">Integrations Settings</span>
        <button
          type="button"
          onClick={handleEditIntegrationSettings}
          className="w-5 underline focus:outline-none"
        >
          {NEW_EDIT_ICON('text-litlingo-primary-120')}
        </button>
      </div>
      {integrationSettings ? (
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-1">
            <p>
              Legal hold: <b>{integrationSettings.legal_hold ? 'Yes' : 'No'}</b>
            </p>
            <p>
              Email and chat retention policy:{' '}
              <b>{integrationSettings.email_chat_retention_policy || 'None'}</b>
            </p>
            <p>
              LitLingo retention policy:{' '}
              <b>{customer?.config?.communication_retention_days || 0} days</b>
            </p>
          </div>
          <p>
            Use Cases:{' '}
            <b>
              {integrationSettings.use_case_uuids
                .map((u) => useCasesOptions.find((us) => us.value === u)?.label)
                .join(',')}
            </b>
          </p>
          <div className="flex flex-col gap-2">
            <p>
              Translations needed: <b>{integrationSettings.translations_needed ? 'Yes' : 'No'}</b>
            </p>
            <p>
              Additional language offerings (besides English) needed for Prevent:{' '}
              <b>{integrationSettings.additional_language_offerings ? 'Yes' : 'No'}</b>
            </p>
            <p>
              Languages for a better Prevent experience:{' '}
              <b>{integrationSettings.languages_for_better_prevent}</b>
            </p>
          </div>
        </div>
      ) : (
        <div className="">Integration settings not defined</div>
      )}
    </div>
  );
};

export default IntegrationSettingsCard;
